import dClient from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {setCurrentBlog} from "./slice";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";


export const getBlogById = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `blog/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setCurrentBlog(res.data.data));
    // return callback && callback(res.data.product.attributes);
};

export const createBlog = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `blog`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editBlog = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `blog/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteBlog = ( id , callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `blog/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback(res);
};